import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { GET_INVESTOR_INFO_BY_ID } from "./apiRoutes";

interface UseGetInvestorInfoByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getInvestorInfoById = async (id: string) =>
  await axiosAuth.get(`${GET_INVESTOR_INFO_BY_ID}/${id}`);

const useGetInvestorInfoById = ({
  id,
  queryParams,
}: UseGetInvestorInfoByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["investor-info", id],
    queryFn: () => getInvestorInfoById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetInvestorInfoById;
